<template>
  <div>
    <category-list v-if="categoryList" :categories="categoryList" />
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import CategoryList from '@/components/organisms/ShopCommerce/CategoryList'
export default {
  name: 'CategoryManual',
  components: {
    CategoryList
  },
  mixins: [contentMixin],
  async fetch () {
    if (this.categoriesIds) {
      this.categoryList = await this.$repositories.category.byGuids(
        this.categoriesIds,
        this.culture
      );
    }
  },
  data () {
    return {
      categoryList: []
    }
  },
  computed: {
    culture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    categoriesIds () {
      return this.content.categories
    }
  }
}
</script>
